// jshint module: true

const component = 'iframe';
const selector = `.${component}`;

let elements = [];

function onLoadHandler() {

  window.requestAnimationFrame(() => event.target.classList.remove('is-hidden'));
  event.target.removeEventListener('load', onLoadHandler, false);

}

function loadIframe(element) {
  const iframe = element.querySelector(`${selector}__iframe`);
  const src = iframe.getAttribute('data-src');

  if (!src) {
    return;
  }

  iframe.classList.add('is-hidden');
  iframe.addEventListener('load', onLoadHandler, false);

  window.setTimeout(() => {
    iframe.setAttribute('src', src);
    iframe.removeAttribute('data-src');
  }, 1000); // NOTE: Dirty extra delay for iframes.

}

function init() {

  elements = document.querySelectorAll(selector);

  if (!elements.length) {
    return;
  }

  for (const element of elements) {
    loadIframe(element);
  }

}

window.addEventListener('init-content-load', init);
window.addEventListener(`reinit-${component}`, init);



// WEBPACK FOOTER //
// ./website/components/iframe/iframe.js